import _concatInstanceProperty from '@babel/runtime-corejs3/core-js-stable/instance/concat';
import _sliceInstanceProperty from '@babel/runtime-corejs3/core-js-stable/instance/slice';
import { c as classNames } from '../../shared/bind-823d2b93.js';
import { jsx } from 'react/jsx-runtime';

var styles = {
  "unit-base": "4",
  "card": "web_ui__Card__card",
  "lifted": "web_ui__Card__lifted",
  "elevated": "web_ui__Card__elevated",
  "primaryLightExperimental": "web_ui__Card__primaryLightExperimental",
  "exposeLightExperimental": "web_ui__Card__exposeLightExperimental",
  "overflowAuto": "web_ui__Card__overflowAuto",
  "overflowHidden": "web_ui__Card__overflowHidden",
  "overflowScroll": "web_ui__Card__overflowScroll",
  "overflowVisible": "web_ui__Card__overflowVisible"
};

var Styling = /*#__PURE__*/function (Styling) {
  Styling["Lifted"] = "lifted";
  Styling["Elevated"] = "elevated";
  return Styling;
}(Styling || {});
var cssClasses = classNames.bind(styles);
var Card = function Card(_ref) {
  var _context;
  var styling = _ref.styling,
    children = _ref.children,
    testId = _ref.testId,
    experimentalTheme = _ref.experimentalTheme,
    _ref$overflow = _ref.overflow,
    overflow = _ref$overflow === void 0 ? 'auto' : _ref$overflow;
  var overflowClass = _concatInstanceProperty(_context = "overflow".concat(overflow.charAt(0).toUpperCase())).call(_context, _sliceInstanceProperty(overflow).call(overflow, 1));
  var cardClass = cssClasses(styles.card, styling, experimentalTheme, overflowClass);
  return /*#__PURE__*/jsx("div", {
    className: cardClass,
    "data-testid": testId,
    children: children
  });
};
Card.Styling = Styling;

export { Card as default };
//# sourceMappingURL=Card.js.map
